import Vue from "vue";
import HcComponents from "@dev/hc-components";
import { HcLocalizerVuePlugin } from "@dev/hc-localization";
import translationsCsCz from "@/translations/cs-CZ.json";
import translationsSkSk from "@/translations/sk-SK.json";
import App from "./App.vue";
import router from "./app/router";
import store from "./app/store";
import { getCulture } from "./app/utils/EnvConfig";

Vue.config.productionTip = false;

Vue.use(
    HcComponents,
    ["HcNewPassword", "HcFormRow", "HcButton", "HcButtonRaw", "HcLinkRaw", "HcMaskedInput", "HcPassword", "HcInput"],
    getCulture()
);

const localizerOptions = {
    defaultCulture: getCulture(),
    translations: getCulture() === 'sk-SK' ? translationsSkSk : translationsCsCz,
};

// TODO: temporary workaround, because hc-localization plugin is already imported and used in hc-components plugin and using here (without object copy) not triggering installation.
Vue.use(Object.create(HcLocalizerVuePlugin), localizerOptions);

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount("#app");
